<template>
    <div class="table-container">
        <div class="table-responsive">
            <table class="table">
                <thead v-if="columns.length">
                    <tr><th v-for="(col, index) in columns" :key="index">{{ col }}</th></tr>
                </thead>
                <tbody>
                    <tr v-for="(row, index) in rows" :key="index">
                        <td v-for="(cell, cellIndex) in row" :key="`${index}-${cellIndex}`">{{ cell }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: "qw-table",
    props: {
        reply: {
            required: false,
            type: Boolean,
            default: true,
        },
        sender: {
            required: false,
            type: String
        },
        columns: {
            required: true,
            type: Array
        },
        rows: {
            required: true,
            type: Array
        }
    },
    computed: {
        date() {
            return +new Date;
        }
    }
}
</script>

<style lang="scss" scoped>
.table-container {
    width: 100%;
    margin: 0px 0px 5px 0px;
    .table {
        margin: 0;
        border: none;
        border-radius: 5px;
        overflow: hidden;
        tr {
            border: none;
            th,td {
                padding: 5px 10px;
                color: $text-color;
                font-family: $lato;
                font-size: 13px;
                border: none;
            }
        }
        thead {
            background-color: $gray;
            border: none;
            tr {
                th, td {
                    font-weight: bold;
                }
            }
        }
        tbody {
            background-color: $white;
            tr {
                border-bottom: 1px solid $lighter-gray;
                @include fastestTransition;
                &:hover {
                    background-color: $lightest-gray;
                }
                &:last-child {
                    border-bottom: none;
                }
            }
        }
    }
}
.dark {
    .table-container {
        .table {
            tr {
                th, td {
                    color: $gray;
                }
            }
            thead {
                background-color: $extra-dark-gray;
            }
            tbody {
                background-color: $darkest-gray;
                tr {
                    border-bottom: 1px solid $darker-gray;
                    &:hover {
                        background-color: $darker-gray;
                    }
                    &:last-child {
                        border-bottom: none;
                    }
                }
            }
        }
    }
}
</style>